import * as yup from "yup";
import { boolean } from "yup";

import type {
  RegistrationData,
  RegistrationFormValues,
} from "./RegistrationForm";

export const registrationSchema = (
  data: RegistrationData,
): yup.ObjectSchema<RegistrationFormValues> => {
  return yup.object().shape({
    nick: yup
      .string()
      .required(data?.validation_required ?? "Required field")
      .min(3, data?.validation_nickname_min_length ?? "Nickname too short")
      .max(16, data?.validation_nickname_max_length ?? "Nickname too long"),
    email: yup
      .string()
      .required(data?.validation_required ?? "Required field")
      .email(data?.validation_invalid_email ?? "Invalid email format"),
    password: yup
      .string()
      .required(data?.validation_required ?? "Required field")
      .min(5, data?.validation_password_min_width ?? "Password too short")
      .max(20, data?.validation_password_max_width ?? "Password too long"),
    bonusCode: yup.string().optional(),
    isRememberPassword: boolean().optional(),
  });
};
